// extracted by mini-css-extract-plugin
module.exports = {"container":"split_container___YaYc","skeleton_animate":"split_skeleton_animate__Np410"};